
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as Part1EarlyYearsIconComponent } from "./part1-early-years-icon.svg";

export const Part1EarlyYearsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <Part1EarlyYearsIconComponent {...props} />;
};
